module.exports = __webpack_public_path__ + "img/photo-05.868bb9e1.jpg";